// extracted by mini-css-extract-plugin
module.exports = {"dialog":"dialog_dialog__pIJ7f"};